module.exports = __webpack_public_path__ + "img/protect-link.a3411c21.gif";